module.exports = __webpack_public_path__ + "img/email.0c6fb142.svg";